module.exports = __webpack_public_path__ + "static/media/virus.49bc6c8b.svg";